import React from "react";
import { Box, Typography, Button } from "@mui/material";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("ErrorBoundary caught:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <Box sx={{
          display: "flex", flexDirection: "column", alignItems: "center",
          justifyContent: "center", minHeight: "100vh", px: 3, textAlign: "center",
          backgroundColor: "#F7F8FA",
        }}>
          <Typography variant="h5" sx={{ fontWeight: 700, color: "#1B3A5C", mb: 2 }}>
            Something went wrong
          </Typography>
          <Typography sx={{ color: "#64748B", mb: 3, maxWidth: 400 }}>
            We encountered an unexpected error. Please try refreshing the page.
          </Typography>
          <Button
            variant="contained"
            onClick={() => window.location.reload()}
            sx={{ backgroundColor: "#1B3A5C", borderRadius: "12px", textTransform: "none" }}
          >
            Refresh Page
          </Button>
        </Box>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
